import Transactions from '../components/transactions/Transactions';
import TransactionsEdit from '../components/transactions/TransactionsEdit';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/transactions',
  component: Template,
  children: [
    {
      path: '',
      name: 'Transactions',
      component: Transactions,
      meta: {
        title: 'Transactions - Mod24',
      },
    },
    {
      path: 'edit/:id',
      name: 'TransactionsEdit',
      component: TransactionsEdit,
      meta: {
        title: 'Edit Transaction - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/transactionsRoutes.js